import React from 'react'
import ReactPlayer from 'react-player'

const formatText = (text: string | undefined) => {
  const regex = /(?:https?:\/\/)?(?:www\.)?(?:(?:youtube\.com\/watch\?v=)|(?:youtu\.be\/))([^\s]+)/g

  const Component = props => {
    if (regex.test(props.item)) {
      return (
        <div className="player-wrapper">
          <ReactPlayer
            className="react-player"
            controls
            url={props.item}
            width="90%"
            height="90%"
          />
        </div>
      )
    }

    if (props.item.match(/^https?:\/\//)) {
      return (
        <a href={props.item} target="_blank" rel="noopener noreferrer">
          {props.item}
        </a>
      )
    }

    return <p>{props.item}</p>
  }

  return text
    ?.replace('\r', '\n')
    .split('\n')
    .map((item, index) =>
      item === '' ? <br key={index} /> : <Component key={index} item={item} />,
    )
}

export default formatText
